import ModalWide from '@ui/components/Modal/variants/ModalWide'
import { Active } from './types'
import ModalBody from './ModalBody'
import { StepOption } from '@order/steps/types'

interface ModalContentProps {
  open: boolean
  close: () => void
  active: Active | null
  setActive: (active: Active) => void
  options: StepOption[]
}

export default function PackageAttributeInfoModal({
  open,
  close,
  active,
  setActive,
  options,
}: ModalContentProps) {
  return (
    <ModalWide
      open={open}
      close={close}
      hideBottomSpace
      center
      cardComponentProps={{
        justifyContent: 'flex-end',
      }}
      showClose
      body={
        active && (
          <ModalBody active={active} setActive={setActive} options={options} />
        )
      }
    />
  )
}
